(function () {
  var SESSION_KEY = 'pooja_booking_done';

  var urlParams = new URLSearchParams(window.location.search);
  var poojaName = urlParams.get('pooja') || '';

  // ── Show pooja name in the page header ───────────────────────────────────
  var nameEl = document.querySelector('.js-pooja-name');
  if (nameEl && poojaName) {
    nameEl.textContent = poojaName;
    nameEl.hidden = false;
  }

  // ── Detect success state ─────────────────────────────────────────────────
  // Covers two paths:
  //   1. Shopify respected return_to → landed on /pages/booking?customer_posted=true
  //   2. Shopify went to /contact → contact-form script redirected here with ?booking_done=1
  //   3. Fallback: sessionStorage flag set before submit
  var hasSuccessParam = urlParams.has('customer_posted') || urlParams.has('booking_done');
  var hasSessionFlag  = sessionStorage.getItem(SESSION_KEY) === '1';

  if (hasSuccessParam || hasSessionFlag) {
    sessionStorage.removeItem(SESSION_KEY);

    var formContent    = document.getElementById('BookingFormContent');
    var successContent = document.getElementById('BookingSuccessContent');
    if (formContent)    formContent.style.display    = 'none';
    if (successContent) successContent.style.display = '';

    // Clean the URL so refreshing doesn't re-show success
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname);
    }
    return;
  }

  // ── Form setup ────────────────────────────────────────────────────────────
  var form = document.querySelector('.pooja-booking-form');
  if (!form) return;

  var submitBtn   = form.querySelector('.pooja-booking-submit');
  var submitSpan  = submitBtn ? submitBtn.querySelector('span') : null;
  var errorBanner = form.querySelector('.pooja-booking-page__error');

  var nameInput   = document.getElementById('BookingName');
  var mobileInput = document.getElementById('BookingMobile');
  var dateInput   = document.getElementById('BookingDate');
  var emailInput  = document.getElementById('BookingEmail');

  // Populate pooja name hidden field from URL
  var poojaHidden = form.querySelector('.js-pooja-hidden');
  if (poojaHidden) poojaHidden.value = poojaName;

  // ── Validation ────────────────────────────────────────────────────────────
  function isValidMobile(val) {
    return /^[\d\s+\-()+]{7,15}$/.test(val.trim());
  }

  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
  }

  function setFieldError(input, show) {
    var field = input.closest('.pooja-booking-page__field');
    var errEl = field ? field.querySelector('.pooja-booking-page__field-error') : null;
    input.classList.toggle('pooja-booking-page__input--error', show);
    if (errEl) errEl.hidden = !show;
  }

  function validate() {
    var ok = true;

    if (!nameInput.value.trim()) {
      setFieldError(nameInput, true); ok = false;
    } else {
      setFieldError(nameInput, false);
    }

    if (!isValidMobile(mobileInput.value)) {
      setFieldError(mobileInput, true); ok = false;
    } else {
      setFieldError(mobileInput, false);
    }

    if (!dateInput.value) {
      setFieldError(dateInput, true); ok = false;
    } else {
      setFieldError(dateInput, false);
    }

    if (emailInput && emailInput.value.trim() && !isValidEmail(emailInput.value)) {
      setFieldError(emailInput, true); ok = false;
    } else if (emailInput) {
      setFieldError(emailInput, false);
    }

    return ok;
  }

  [nameInput, mobileInput, dateInput, emailInput].forEach(function (el) {
    if (!el) return;
    el.addEventListener('input',  function () { setFieldError(el, false); });
    el.addEventListener('change', function () { setFieldError(el, false); });
  });

  // ── Submit ────────────────────────────────────────────────────────────────
  form.addEventListener('submit', function (e) {
    if (!validate()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (errorBanner) errorBanner.hidden = false;
      return;
    }

    if (errorBanner) errorBanner.hidden = true;

    // Copy visible email into the hidden contact[email] field Shopify requires
    var emailHidden = document.getElementById('BookingEmailHidden');
    if (emailHidden) {
      emailHidden.value = (emailInput && emailInput.value.trim())
        ? emailInput.value.trim()
        : 'no-reply@divinesarthi.com';
    }

    // Set flag BEFORE navigating away — used by both the success param check
    // (if return_to works) and the contact-page redirect (if it doesn't)
    sessionStorage.setItem(SESSION_KEY, '1');

    if (submitBtn) submitBtn.disabled = true;
    if (submitSpan) submitSpan.textContent = 'Submitting...';

    // Let the form submit naturally so Shopify's bot protection token is included
  });
})();
